import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import trans from 'utils/i18n';

const initOptions = {
  fallbackLng: 'ru',
  resources: trans,
  lng: 'ru',
  debug: false,
  backend: {
    loadPath: 'utils/i18n/{{lng}}/{{lng}}.json',
  },
};

i18n.use(Backend).use(initReactI18next).init(initOptions);

export default i18n;
